<ion-app>
  <ion-router-outlet></ion-router-outlet>
  <app-cookie-banner></app-cookie-banner>
</ion-app>
